import { useCallback, useTransition } from "react";
import { useTypedSearchParams } from "react-router-typesafe-routes";

import { v2Route } from "~/v2/routes";
import { GeoItemsPresenter } from "./geoItems.presenter";

const DEFAULT_PAGE_SIZE = 25;

export function GeoItemsContainer() {
  const [params, setParams] = useTypedSearchParams(v2Route.geoItems);
  const [isPending, startTransition] = useTransition();
  const pageIndex = params.page ?? 0;
  const pageSize = params.pageSize ?? DEFAULT_PAGE_SIZE;

  const onSearch = useCallback(
    (label: string | undefined) => {
      setParams((prev) => ({ ...prev, label, page: undefined }));
    },
    [setParams],
  );
  const onPageIndexChange = useCallback(
    (next: number) => {
      startTransition(() => setParams((prev) => ({ ...prev, page: next === 0 ? undefined : next })));
    },
    [setParams],
  );
  const onPageSizeChange = useCallback(
    (next: number) => {
      startTransition(() =>
        setParams((prev) => ({
          ...prev,
          pageSize: next === DEFAULT_PAGE_SIZE ? undefined : next,
          page: undefined,
        })),
      );
    },
    [setParams],
  );

  return (
    <GeoItemsPresenter
      label={params.label}
      pageIndex={pageIndex}
      pageSize={pageSize}
      isPending={isPending}
      onSearch={onSearch}
      onPageIndexChange={onPageIndexChange}
      onPageSizeChange={onPageSizeChange}
    />
  );
}
